import React, { useEffect, useRef, useState } from 'react';

import { BulkDataTextarea, IBulkDataTextareaAPI, SearchDropdown, SearchItem } from 'components';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@cfa/react-components';
import { FiltersService, ISearcherOnSearchResponse, LocationGroupsService, TemplatesService, UsersService } from 'services';
import { ILocationGroup, ITemplate } from 'interfaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


interface ITemplatesModalProps {
    show: boolean,
    onCancel: () => void,
    onSubmit: (tID: number, locs: string[]) => void,
}

export function TemplatesModal({ show, onCancel, onSubmit }: ITemplatesModalProps) {
    
    const [template, setTemplate] = useState<ITemplate>(undefined);
    const locationsTextareaRef = useRef<IBulkDataTextareaAPI>();
        
    function onChangeTemplateID(e) {
        const id = e.target.value;

        console.log("changing to ", id);

        const t = TemplatesService.allTemplatesMap[id];
        if (!t) {
            console.error('Missing template for id: ', id);
            return;
        }
        
        setTemplate(t);
    }

    useEffect(() => {
        if (show) {
            setTemplate(TemplatesService.allTemplates[0]);
        }
    }, [show])

    function onSubmitTemplate() {
        if (!template) {
            return;
        }

        const { lines, isValid } = locationsTextareaRef.current.getLinesAndValidate();
        if (!isValid || lines.length === 0) {
            return;
        }
        
        onSubmit(template.id, lines);
        
        setTemplate(undefined);
    }

    function onCancelTemplate() {
        onCancel();
        setTemplate(undefined);
    }

    return (
        <Modal show={show} onClose={onCancel}>
            <ModalHeader>
                    Create Update from Template
            </ModalHeader>
            <ModalBody>
                <div className="row" style={{'marginTop': '0px'}}>
                    <div className="col">
                        <div className="formItem">
                            <div className="formItem_label">
                                Template
                            </div>
                            <select
                                className="formItem_select"
                                defaultValue={template?.name}
                                onChange={onChangeTemplateID}
                            >
                                {TemplatesService.allTemplates.map(t => (
                                    <option key={t.id} value={t.id}>
                                        {t.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="formItem">
                            <div className="targetCountsBadge targetCountsBadge_last targetCountsBadge_bottom">
                                <FontAwesomeIcon icon="info-circle" />&nbsp;
                                    Optional - Enter a comma or space separated list of locations, or select a location group. Each location must be a 5 digit number.
                            </div>
                            <SearchDropdown<ILocationGroup>
                                className="filterModal_locationGroupsSearch"
                                getOptionValue={g => g.name}
                                onChange={g =>  {
                                        locationsTextareaRef.current.setTextarea(g.locations)
                                    }
                                }
                                onSearch={(q: string, offset: number): ISearcherOnSearchResponse<ILocationGroup> => {
                                    return Promise.resolve({
                                        results: LocationGroupsService.locationGroups.filter(v => v.name.toLowerCase().includes(q.toLowerCase())),
                                        canLoadMore: false, 
                                    })
                                }}
                                renderOption={(option) => (
                                    <SearchItem label={option.name} />
                                )}
                                value={undefined}
                                placeholder="Select a location group"
                            />

                            <BulkDataTextarea 
                                defaultLines={[]}
                                itemName="location"
                                itemNamePlural="locations"
                                lineValidRegex={FiltersService.regexLocation}
                                readOnly={false}
                                ref={locationsTextareaRef}
                            />
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    variant="outlined"
                    onClick={onCancelTemplate}
                >
                    Cancel
                </Button>
                <Button
                    style={{marginLeft: "10px"}}
                    onClick={onSubmitTemplate}
                    disabled={!template}
                >
                    Save
                </Button>
            </ModalFooter>
        </Modal>
    );
}